export { default } from './SearchTypeDropdown';



// WEBPACK FOOTER //
// ./app/components/search/SearchTypeDropdown/index.js